module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isLoad && !_vm.isLoadDoc) ? [(_vm.step == 1) ? [_c('ui_title_line', {
    attrs: {
      "no_left": ""
    }
  }, [_vm._v("\n        ОТМЕНА ПРИКАЗА\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col li-cancel"
  }, [_c('ui_title', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_vm._v("\n                  ПРЕИМУЩЕСТВА\n                ")]), _vm._v(" "), _c('ul', [_c('li', [_c('ui_text', [_vm._v("Алгоритмы заявлений для мировых судей или арбитражных судов")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Алгоритмы для отмены требований по налогам, алиментам, коммунальным платежам, кредитам и займам")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Генерация обоснования пропущенного срока по необходимости")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Автоматический подбор правильных реквизитов организаций")])], 1)]), _vm._v(" "), _c('ui_btn', {
    on: {
      "click": _vm.toCancel
    }
  }, [_vm._v("Отменить судебный приказ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "cancel-title"
  }, [_c('ui_title', {
    staticStyle: {
      "margin": "50px 0"
    }
  }, [_vm._v("Информация для отмены судебного приказа и восстановления сроков")])], 1), _vm._v(" "), _c('p', {
    staticClass: "cancel-text"
  }, [_c('ui_text', [_vm._v("Наш уникальный сервис позволит Вам автоматически создать и отправить в суд все необходимые документы для отмены судебного приказа. Загрузите фотографию судебного приказа или введите данные вручную - система распознает данные и подготовит материалы для отправки. После оплаты мы автоматически отправим подписанные документы в суд, а также копию письма с файлами на Вашу электронную почту.")])], 1)])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 mobile-padding",
    attrs: {
      "id": "info"
    }
  }, [_c('ui_title', {
    staticStyle: {
      "margin": "50px 0"
    }
  }, [_vm._v("\n            Бесплатное изготовление и просмотр готового документа\n          ")]), _vm._v(" "), _c('ui_text', [_vm._v("\n            Стоимость услуги по отмене судебного приказа составляет "), _c('span', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.settings.priceСancellation) + " руб")]), _vm._v(".\n          ")]), _vm._v(" "), _c('ui_sub_title_text', {
    staticStyle: {
      "margin": "1em 0"
    },
    attrs: {
      "name": "info"
    }
  }, [_vm._v("\n            В услугу отмены приказа входят:\n          ")]), _vm._v(" "), _c('ul', [_c('li', [_c('ui_text', [_vm._v("Автоматическое распознавание изображения судебного приказа (при надлежащем качестве фото)")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Автоматическое формирование документов с подписью адвоката")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Отправка документов на электронный адрес судьи")])], 1), _vm._v(" "), _c('li', [_c('ui_text', [_vm._v("Отправка копии письма заявителю")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col row-dowload-button"
  }, [_c('input', {
    ref: "filePasport",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChange
    }
  }), _vm._v(" "), _c('ui_btn', {
    on: {
      "click": function($event) {
        return _vm.$refs.filePasport.click()
      }
    }
  }, [_vm._v("\n              Загрузить фото приказа\n            ")]), _vm._v(" "), _c('ui_btn', {
    on: {
      "click": function($event) {
        return _vm.nextStep(2)
      }
    }
  }, [_vm._v("\n              Ввести данные вручную\n            ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "50px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select.isTrue3),
      expression: "select.isTrue3"
    }],
    staticStyle: {
      "margin-right": "1em"
    },
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.select.isTrue3) ? _vm._i(_vm.select.isTrue3, null) > -1 : (_vm.select.isTrue3)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.select.isTrue3,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.select, "isTrue3", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.select, "isTrue3", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.select, "isTrue3", $$c)
        }
      }
    }
  }), _c('ui_sub_text', [_vm._v(" Загружая файл или нажимая на кнопку \"Ввести данные вручную\", я подтверждаю согласие с "), _c('a', {
    staticStyle: {
      "color": "rgb(152, 16, 16) !important"
    },
    attrs: {
      "href": "../../static/pdf-fiels/publicoffert2.pdf",
      "target": "_blank"
    }
  }, [_vm._v(" Публичной Офертой отмены судебного приказа ")]), _vm._v(" и "), _c('a', {
    staticStyle: {
      "color": "rgb(152, 16, 16) !important"
    },
    attrs: {
      "href": "/polit",
      "target": "_blank"
    }
  }, [_vm._v(" Политикой Конфиденциальности ")])])], 1)], 1)])] : _vm._e(), _vm._v(" "), (_vm.step == 2) ? [_c('ui_title_line', {
    attrs: {
      "no_left": ""
    }
  }, [_vm._v("\n        ПРОВЕРЬТЕ ВАШИ ДАННЫЕ\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col check-cancel"
  }, [_c('ui_text', [_vm._v("Проверьте все указанные данные, при несовпадении информации просим вас вернуться назад и загрузить другую фотографию документа, либо заполнить данные самостоятельно")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "inputs-wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col input-row"
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('+7(###)-###-##-##'),
      expression: "'+7(###)-###-##-##'"
    }],
    attrs: {
      "outlined": "",
      "rounded": "",
      "error-messages": _vm.phoneErrors(),
      "required": "",
      "label": "Ваш номер телефона"
    },
    on: {
      "input": function($event) {
        return _vm.$v.select.phone.$touch()
      },
      "blur": function($event) {
        return _vm.$v.select.phone.$touch()
      }
    },
    model: {
      value: (_vm.select.phone),
      callback: function($$v) {
        _vm.$set(_vm.select, "phone", $$v)
      },
      expression: "select.phone"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col input-row"
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "rounded": "",
      "error-messages": _vm.emailErrors(),
      "required": "",
      "label": "Ваш Email"
    },
    on: {
      "input": function($event) {
        return _vm.$v.select.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.select.email.$touch()
      }
    },
    model: {
      value: (_vm.select.email),
      callback: function($$v) {
        _vm.$set(_vm.select, "email", $$v)
      },
      expression: "select.email"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col input-row"
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "nudge-width": 0,
      "close-on-content-click": true,
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-text-field', {
          attrs: {
            "outlined": "",
            "rounded": "",
            "error-messages": _vm.emailSudErrors(),
            "required": "",
            "hide-details": "",
            "autocomplete": "none",
            "label": "Email судьи"
          },
          on: {
            "input": function($event) {
              return _vm.$v.select.emailSud.$touch()
            },
            "blur": function($event) {
              return _vm.$v.select.emailSud.$touch()
            }
          },
          model: {
            value: (_vm.select.emailSud),
            callback: function($$v) {
              _vm.$set(_vm.select, "emailSud", $$v)
            },
            expression: "select.emailSud"
          }
        })], 1)]
      }
    }, (_vm.select.emailSud) ? {
      key: "default",
      fn: function() {
        return [_c('v-card', {
          staticStyle: {
            "max-height": "200px"
          }
        }, [(_vm.loading.emailSud) ? [_c('div', {
          staticStyle: {
            "justify-content": "center",
            "display": "flex",
            "padding": "10px"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "red"
          }
        })], 1)] : [(_vm.judges.length > 0) ? [_c('v-list', _vm._l((_vm.judges), function(item, index) {
          return _c('v-list-item', {
            key: index,
            on: {
              "click": function($event) {
                return _vm.selectJudges(item)
              }
            }
          }, [_c('v-list-item-title', [_vm._v(_vm._s(item.email))])], 1)
        }), 1)] : [_c('div', {
          staticStyle: {
            "justify-content": "center",
            "display": "flex",
            "padding": "10px"
          }
        }, [_c('i', [_vm._v("совпадений не найдено")])])]]], 2)]
      },
      proxy: true
    } : null], null, true)
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    ref: "rowuchastok",
    staticClass: "col input-row"
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "nudge-width": 0,
      "close-on-content-click": true,
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('v-textarea', {
          attrs: {
            "hide-details": "",
            "autocomplete": "none",
            "error-messages": _vm.uchastokErrors(),
            "required": "",
            "outlined": "",
            "rounded": "",
            "content-class": "elevation-0",
            "label": "Адресc судебного участка",
            "placeholder": "№ 348 Савеловского района г.Москвы 125252. г.Москва. Ходынский бульвар, д.5, корп.З"
          },
          on: {
            "input": function($event) {
              return _vm.$v.select.uchastok.$touch()
            },
            "blur": function($event) {
              return _vm.$v.select.uchastok.$touch()
            }
          },
          model: {
            value: (_vm.select.uchastok),
            callback: function($$v) {
              _vm.$set(_vm.select, "uchastok", $$v)
            },
            expression: "select.uchastok"
          }
        })], 1)]
      }
    }, (_vm.select.uchastok) ? {
      key: "default",
      fn: function() {
        return [_c('v-card', {
          ref: "adresslist",
          staticStyle: {
            "max-height": "200px"
          }
        }, [(_vm.loading.uchastok) ? [_c('div', {
          staticStyle: {
            "justify-content": "center",
            "display": "flex",
            "padding": "10px"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "red"
          }
        })], 1)] : [(_vm.judges.length > 0) ? [_c('v-list', _vm._l((_vm.judges), function(item, index) {
          return _c('v-list-item', {
            key: index,
            on: {
              "click": function($event) {
                return _vm.selectJudges(item)
              }
            }
          }, [_c('div', [_c('v-list-item-title', {
            staticClass: "text-wrap pb-2"
          }, [_vm._v("\n                                    " + _vm._s(item.adress) + "\n                                  ")])], 1)])
        }), 1)] : [_c('div', {
          staticStyle: {
            "justify-content": "center",
            "display": "flex",
            "padding": "10px"
          }
        }, [_c('i', [_vm._v("совпадений не найдено")])])]]], 2)]
      },
      proxy: true
    } : null], null, true)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col input-row"
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "rounded": "",
      "error-messages": _vm.adressErrors(),
      "required": "",
      "content-class": "elevation-0",
      "label": "Адресc заявителя",
      "placeholder": "г. Москва, Петровско-Разумовский проезд, 123 к.1, кв. 123."
    },
    on: {
      "input": function($event) {
        return _vm.$v.select.adress.$touch()
      },
      "blur": function($event) {
        return _vm.$v.select.adress.$touch()
      }
    },
    model: {
      value: (_vm.select.adress),
      callback: function($$v) {
        _vm.$set(_vm.select, "adress", $$v)
      },
      expression: "select.adress"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col input-row"
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.fioErrors(),
      "required": "",
      "color": "grey",
      "outlined": "",
      "rounded": "",
      "label": "ФИО заявителя"
    },
    on: {
      "input": function($event) {
        return _vm.$v.select.fio.$touch()
      },
      "blur": function($event) {
        return _vm.$v.select.fio.$touch()
      }
    },
    model: {
      value: (_vm.select.fio),
      callback: function($$v) {
        _vm.$set(_vm.select, "fio", $$v)
      },
      expression: "select.fio"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col input-row"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "error-messages": _vm.dtErrors(),
            "required": "",
            "label": "Дата судебного приказа",
            "prepend-icon": "mdi-calendar",
            "readonly": "",
            "outlined": "",
            "rounded": ""
          },
          on: {
            "input": function($event) {
              return _vm.$v.select.dt.$touch()
            },
            "blur": function($event) {
              return _vm.$v.select.dt.$touch()
            }
          },
          model: {
            value: (_vm.select.dt),
            callback: function($$v) {
              _vm.$set(_vm.select, "dt", $$v)
            },
            expression: "select.dt"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 2866204527),
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu2 = false
      }
    },
    model: {
      value: (_vm.select.dt),
      callback: function($$v) {
        _vm.$set(_vm.select, "dt", $$v)
      },
      expression: "select.dt"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col input-row"
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.deloErrors(),
      "required": "",
      "color": "grey",
      "outlined": "",
      "rounded": "",
      "label": "№ дела"
    },
    on: {
      "input": function($event) {
        return _vm.$v.select.delo.$touch()
      },
      "blur": function($event) {
        return _vm.$v.select.delo.$touch()
      }
    },
    model: {
      value: (_vm.select.delo),
      callback: function($$v) {
        _vm.$set(_vm.select, "delo", $$v)
      },
      expression: "select.delo"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('v-row', [_c('v-col', [_c('v-select', {
    attrs: {
      "error-messages": _vm.sudiaErrors(),
      "required": "",
      "items": _vm.typeSud,
      "item-text": 'name',
      "item-value": 'id',
      "input-value": "select.sudia",
      "label": "Судья",
      "outlined": "",
      "rounded": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.select.sudia.$touch()
      },
      "blur": function($event) {
        return _vm.$v.select.sudia.$touch()
      }
    },
    model: {
      value: (_vm.select.sudia),
      callback: function($$v) {
        _vm.$set(_vm.select, "sudia", $$v)
      },
      expression: "select.sudia"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select.isTrue),
      expression: "select.isTrue"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.select.isTrue) ? _vm._i(_vm.select.isTrue, null) > -1 : (_vm.select.isTrue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.select.isTrue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.select, "isTrue", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.select, "isTrue", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.select, "isTrue", $$c)
        }
      }
    }
  }), _vm._v("\n               Деньги уже списались/приказ вступил в силу?\n            ")]), _vm._v(" "), _c('v-col', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select.isTrue2),
      expression: "select.isTrue2"
    }],
    attrs: {
      "type": "checkbox",
      "error-messages": _vm.isTrue2Errors(),
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.select.isTrue2) ? _vm._i(_vm.select.isTrue2, null) > -1 : (_vm.select.isTrue2)
    },
    on: {
      "input": function($event) {
        return _vm.$v.select.isTrue2.$touch()
      },
      "blur": function($event) {
        return _vm.$v.select.isTrue2.$touch()
      },
      "change": function($event) {
        var $$a = _vm.select.isTrue2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.select, "isTrue2", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.select, "isTrue2", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.select, "isTrue2", $$c)
        }
      }
    }
  }), _vm._v("\n               Я согласен(на) с "), _c('a', {
    staticStyle: {
      "color": "rgb(152, 16, 16) !important"
    },
    attrs: {
      "href": "/privacy",
      "target": "_blank"
    }
  }, [_vm._v("Политикой Конфиденциальности")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-red-grey-button"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('v-row', [_c('v-col', [_c('ui_btn', {
    attrs: {
      "type": "gray-btn"
    },
    on: {
      "click": function($event) {
        return _vm.lastStep(1)
      }
    }
  }, [_vm._v(" Вернуться назад")])], 1), _vm._v(" "), _c('v-col', [_c('ui_btn', {
    on: {
      "click": function($event) {
        return _vm.send()
      }
    }
  }, [_vm._v(" Сформировать документы")]), _vm._v(" "), (_vm.$v.select.$invalid) ? _c('span', {
    staticStyle: {
      "color": "darkred",
      "font-weight": "bolder"
    }
  }, [_vm._v("Проверьте поля!")]) : _vm._e()], 1)], 1)], 1)])] : _vm._e(), _vm._v(" "), (_vm.step == 3) ? [_c('ui_title_line', {
    attrs: {
      "no_left": ""
    }
  }, [_vm._v("\n        ПРОВЕРЬТЕ ВАШИ ДАННЫЕ\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 wrapper-iframe"
  }, [_c('button', {
    staticClass: "is-mobile red-button",
    on: {
      "click": function($event) {
        return _vm.dowloadPdf()
      }
    }
  }, [_vm._v("Открыть пдф")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "id": "iframe",
      "width": "100%",
      "height": "100%",
      "src": _vm.pdfBlobURL + '#toolbar=0'
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row row-red-grey-button last-step-row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select.isTrue2),
      expression: "select.isTrue2"
    }],
    attrs: {
      "type": "checkbox",
      "error-messages": _vm.isTrue2Errors(),
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.select.isTrue2) ? _vm._i(_vm.select.isTrue2, null) > -1 : (_vm.select.isTrue2)
    },
    on: {
      "input": function($event) {
        return _vm.$v.select.isTrue2.$touch()
      },
      "blur": function($event) {
        return _vm.$v.select.isTrue2.$touch()
      },
      "change": function($event) {
        var $$a = _vm.select.isTrue2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.select, "isTrue2", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.select, "isTrue2", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.select, "isTrue2", $$c)
        }
      }
    }
  }), _vm._v("\n                Нажимая на кнопку \"Оплатить и отправить документы\" я принимаю "), _c('a', {
    staticStyle: {
      "color": "rgb(152, 16, 16) !important"
    },
    attrs: {
      "href": "../../static/pdf-fiels/publicoffert.pdf",
      "target": "_blank"
    }
  }, [_vm._v(" условия Договора-оферты.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('ui_btn', {
    attrs: {
      "type": "gray-btn"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep(2)
      }
    }
  }, [_vm._v(" Вернуться назад")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('ui_btn', {
    on: {
      "click": function($event) {
        return _vm.toPay()
      }
    }
  }, [_vm._v(" Оплатить и отправить документы")])], 1)])], 1)])] : _vm._e(), _vm._v(" "), (_vm.step == 4) ? [_c('div', [_c('ui_title_line', {
    attrs: {
      "no_left": ""
    }
  }, [_vm._v("\n          ОПЛАТА\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row pre-title"
  }, [_c('div', {
    staticClass: "col offset-md-2 col-md-8"
  }, [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "col offset-md-2 col-md-8 pt-8"
  }, [_c('div', {
    attrs: {
      "id": "payment-form"
    }
  })])])], 1)], 1)])], 1)] : _vm._e(), _vm._v(" "), (_vm.step == 5) ? [_c('div', {
    staticClass: "wrapper-loading"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "loading-text"
  }, [_c('ui_text', [_vm._v("Письмо успешно отправлено на почту Мирового судьи. Копия письма отправлена на Вашу почту.")]), _c('br')], 1)], 1)], 1)] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isLoad) ? [_c('div', {
    staticClass: "wrapper-loading"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "loading-text"
  }, [_c('ui_text', [_vm._v("Пожалуйста подождите, файл проходит проверку")]), _c('br'), _vm._v(" "), _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "red"
    }
  })], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.isLoadDoc) ? [_c('div', {
    staticClass: "wrapper-loading"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "loading-text"
  }, [_c('ui_text', [_vm._v("Пожалуйста подождите, подготавливаем документ")]), _c('br'), _vm._v(" "), _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "red"
    }
  })], 1)], 1)], 1)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5 col-img-cancel"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/docs.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col img-only-cancel"
  }, [_c('img', {
    staticClass: "is-desctop",
    attrs: {
      "src": "/static/img/lineImgCancel.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "is-mobile",
    attrs: {
      "src": "/static/img/lineImgCancelMobile.svg"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-2 col-img-center min-conent"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/warning-icon.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46424766","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cancel/cancel.vue
// module id = 355
// module chunks = 2